<template>
  <main-layout></main-layout>
</template>

<script>
/* ============
 * Home Index Page
 * ============
 *
 * The home index page.
 */

import MainLayout from "@/layouts/Main.vue"

export default {
  /**
   * The name of the page.
   */
  name: "Home",

  /**
   * The components that the page can use.
   */
  components: {
    MainLayout
  }
}
</script>
